export enum ProductStandardField {
    sku = 'sku',
    ean = 'ean',
    externalId = 'externalId',
    manufacturer = 'manufacturer',
    supplier = 'supplier',
    type = 'type',
    description = 'description',
    availability = 'availability',
    floorHeating = 'structure.floorHeating',
    baseIntegrated = 'installation.baseIntegrated',
    waterResistance = 'technicalParameters.waterResistance',
    structure = 'structure.structure',
}
